<template>
  <div>
    <ministry-breadcrumbs :mainTitle="mainTitle" :breadcrumbs="breadcrumbs" />
    <b-card>
      <div style="position: relative">
        <b-row class="justify-content-between px-1 align-items-center">
          <div class="d-flex align-items-center w-50">
            <h3 class="w-50">سجل عمليات مسح QR</h3>
          </div>

          <b-button
            v-can="{ slug: $route.meta.slug, action: 'C' }"
            @click="
              $router.push({
                name: 'file-view',
                query: { ep: dataObj[0].ngoFileQR.path },
              })
            "
            variant="success"
            >عرض الطلب</b-button
          >
        </b-row>
        <hr />
        <data-table
          id="ngos-table"
          :ep.sync="ep"
          :fields="fields"
          ref="ngosTable"
        >
          <template #cell(created_at)="{ value }">
            <span
              >{{ value ? $moment(value).format("HH:mm DD-MM-YYYY") : "" }}
            </span>
          </template>
        </data-table>
      </div>
    </b-card>
  </div>
</template>

<script>
import { BRow, BCol, BCard, BButton } from "bootstrap-vue";
import DataTable from "@/components/data-table";
import MinistryBreadcrumbs from "@/modules/ministry/components/MinistryBreadcrumbs.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  props: ["id"],
  components: {
    BRow,
    BCol,
    BCard,
    DataTable,
    MinistryBreadcrumbs,
    BButton,
  },
  created() {
    this.fetchRecordData(this.id);
  },

  computed: {
    ...mapGetters("Ministry/Settings/MediationRequestes", ["dataObj"]),
  },
  methods: {
    ...mapActions("Ministry/Settings/MediationRequestes", ["fetchRecordData"]),
  },
  data() {
    return {
      mainTitle: "إدارة المعاملات",

      type: "ADD",
      ep: `v2/ministry/files-qrs/get-file-qr-logs/${this.id}`,

      fields: [
        { label: "المعرف", key: "id" },
        { label: "تاريخ المسح", key: "created_at" },
        { label: "وجهة الملف", key: "ngoFileQR.destination" },
        { label: "حالة المنظمة عند مسح الملف ", key: "status.name_ar" },
      ],
      breadcrumbs: [
        {
          // old
          // text: "الإعدادات",
          // new
          text: "إدارة المنظمات",
          to: "/ministry/ngos-communication",
        },
        {
          text: "معاملات التوسّط",
          // old
          // to: "/ministry/settings/mediation-requestes",
          // new
          
          to: "/ministry/ngos-communication/mediation-requestes",
        },
        {
          text: "سجل عمليات مسح QR",
          active: true,
        },
      ],
    };
  },
};
</script>
